import { isMutationSuccess } from 'src/helpers/mutations';

export const isSuccess = (result: { status?: number } | undefined): boolean => isMutationSuccess(result);
